export function ParseKeyData(keyData) {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(keyData, "text/xml");
    const xPath = 'MultipleComponentsMapping Components Component Variables Variable Value';
    let value = xmlDoc.querySelector(xPath).textContent;
    value = value.replace(/(\w+):/g, '"$1":');
    value = value.replace(/(\w+) :/g, '"$1":');
    const json = JSON.parse('{' + value + '}');

    const parts = [];
    for (const item in json)
    {
        parts.push(json[item]);
    }

    return parts;
}
